<script lang="ts">
    
    import { navigate } from "svelte-navigator";
    import { Alert, Button, FormGroup, Icon, Label } from "sveltestrap";
    import { MANAGER_ID, SUPERADMIN_ID } from "../environment";
    import { loginService, meService } from "../Services";
    import ControlFeedback from "./ControlFeedback.svelte";
    import InvalidFeedback from "./InvalidFeedback.svelte";

    const defaultNavigation = {
        [SUPERADMIN_ID] : () => navigate('/cuentas'),
        [MANAGER_ID]    : () => navigate('/manager'),
    };

    let isLogging = false;
    let loginError = false;
    let loginErrorMessage = 'Parece que los datos de acceso no son válidos.';
    let email = '';
    let password = '';

    async function onSubmit() {
        loginError = false;
        if (isLogging) {
            return;
        }
        isLogging = true;
        try {
            const { error } = await loginService.login(email, password);
            
            if (error) {
                loginErrorMessage = error;
                loginError = true;
                return;
            }

            email = '';
            password = '';
            // const me = await meService.getMePromise();

            defaultNavigation[2]();
        } catch (error) {
            console.error(error);
            loginError = true;
            isLogging = false;
        } finally {
            isLogging = false;
        }
    }

</script>

<form on:submit|preventDefault={onSubmit} class="p-3 bg-white rounded" novalidate>

    <img class="game-name" src="/images/game-name.png" alt="BinFun">

    <FormGroup>
        <ControlFeedback let:input let:valueMissing let:typeMismatch>
            <Label>Email</Label>
            <input type="email" required class="form-control" bind:value={email}>
            <InvalidFeedback show={input && valueMissing}>
                <Icon name="exclamation-triangle" /> Debe indicar una dirección de correo.
            </InvalidFeedback>
            <InvalidFeedback show={typeMismatch}>
                <Icon name="exclamation-triangle" /> Esto no parece una dirección de correo.
            </InvalidFeedback>
        </ControlFeedback>
    </FormGroup>

    <FormGroup>
        <ControlFeedback let:input let:valueMissing>
            <Label>Password</Label>
            <input type="password" required class="form-control" bind:value={password}>
            <InvalidFeedback show={input && valueMissing}>
                <Icon name="exclamation-triangle" /> Debe indicar una contraseña.
            </InvalidFeedback>
        </ControlFeedback>
    </FormGroup>

    {#if loginError}
        <Alert color="danger">
            {loginErrorMessage}
        </Alert>
    {/if}

    <Button type="submit" color="primary" disabled={isLogging}>
        Entrar
    </Button>

</form>

<style lang="scss">

    .game-name {
        max-width: 100%;
        margin: 1rem 0 2rem;
    }

</style>
